/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Model_Region_EuInputs */



/**
* | output |
* | --- |
* | "EU hosted" |
*
* @param {Uno_Settings_Model_Region_EuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_model_region_eu = /** @type {((inputs?: Uno_Settings_Model_Region_EuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Model_Region_EuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In der EU gehostet")
	return /** @type {LocalizedString} */ ("EU hosted")
});